import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';

import type { User } from '@recruitee/account-types';
import { trackByProp } from '@recruitee/common';
import { I18nService } from '@recruitee/i18n';
import {
  AvatarComponent,
  ButtonLoadingDirective,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  RtTooltip,
} from '@recruitee/user-interface';
import { RoleWithAdmins } from '@recruitee/visibility';

@Component({
  selector: 'rt-team-members-item',
  templateUrl: 'team-members-item.component.html',
  styleUrls: ['./team-members-item.component.less'],
  imports: [
    AvatarComponent,
    ButtonLoadingDirective,
    HeadingComponent,
    IconButtonComponent,
    IconComponent,
    RtTooltip,
    NgTemplateOutlet,
  ],
  host: {
    '[class.is-last]': 'isLast',
  },
})
export class TeamMembersItemComponent {
  @Input() public removable: boolean = false;
  @Input() public collapsable: boolean = false;
  @Input() public isSimple: boolean = false;
  @Input() public isLast: boolean = false;
  @Input() public admin: User | null = null;
  @Input() public roleWithAdmins: RoleWithAdmins | null = null;
  @Input() public adminInRemove: number | null = null;
  @Input() public hasPadding: boolean = false;
  @Input() public hasManageSettingsButton: boolean = false;
  @Input() public hasNoBorderBottom: boolean = false;
  @Input() public hasCheckboxOffset: boolean = false;
  @Input() public roleDescription: string = '';
  @Input() public isDisabled: boolean = false;
  @Input() public removeTooltipText: string = this.i18n.translate(
    'app.offer_assignments.remove_recruiter',
  );
  @Input() public headingSlotTemplate: TemplateRef<any> | null = null;

  @Output() public removeFollower: EventEmitter<User> = new EventEmitter();
  @Output() public goToManageRole: EventEmitter<number> = new EventEmitter();
  @Output() public itemExpanded: EventEmitter<void> = new EventEmitter();

  public trackById = trackByProp<{ id: number }>({ prop: 'id' });
  public expanded: boolean = false;

  constructor(
    protected cdRef: ChangeDetectorRef,
    private i18n: I18nService,
    public elRef: ElementRef,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.roleWithAdmins && changes.roleWithAdmins.currentValue) {
      this.expanded = changes.roleWithAdmins.currentValue.expanded;
      this.cdRef.detectChanges();
    }
  }

  public toggleList(): void {
    this.expanded = !this.expanded;
    this.cdRef.detectChanges();
    if (this.expanded) this.itemExpanded.emit();
  }

  public trackByIndex(index: number, _: any): number {
    return index;
  }
}
